var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.54353C1.80607 7.24618 3.71204 7.65835 5.64706 7.76471V9.17647H8.47059V7.76471C10.4009 7.64381 12.3033 7.24193 14.1176 6.57176V12H0V6.54353ZM9.17647 0L9.88235 0.705882V2.11765H14.1176V5.79529C11.9533 6.60339 9.66542 7.03087 7.35529 7.05882H6.84706C4.50592 7.03352 2.18777 6.59379 0 5.76V2.11765H4.23529V0.705882L4.94118 0H9.17647ZM8.47059 1.41176H5.64706V2.11765H8.47059V1.41176Z",
    fill: "#CD2A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusHistoryIcon);
export default __webpack_public_path__ + "static/media/statusHistoryIcon.7b800de6636bffbfe0b8db59694a9fb5.svg";
export { ForwardRef as ReactComponent };